<template>
  <div class="news-feed">
    <van-list v-model="loading" :finished="finished" @load="onLoad">
      <div v-for="(item, index) in list" :key="index" class="cell-container">
        <van-cell is-link @click="goDetails(item)">
          <template #title>
            <div class="news-title">
                <div class="title" v-if="item.type=='新增'" >患者服务</div>
                <div class="title" v-else style="color:#888888;" >患者服务</div>
                <!-- <van-tag v-if="item.type=='患者服务'" class="new" type="warning" ><i>NEW</i></van-tag> -->
                <van-tag v-if="item.type=='新增'" class="new" type="warning" ><i>NEW</i></van-tag>
            </div>
          </template>
          <!-- <template #label></template> -->
          {{item.updated}}
        </van-cell>
        <div class="content">{{item.content}}</div>
      </div>

      <template #finished>
        <van-divider :style="{color: '#bababa', borderColor: '#bababa', padding: '0 80px', }"  >
          <div style=" width: 3px; height: 3px; border-radius: 100%; background-color: #bababa; " ></div>
        </van-divider>
      </template>
    </van-list>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getPatientServiceList,sendQaStatus } from '@/api/publicWelfareStaff';

export default {
    data() {
        return {
            list:[],
            loading:false,
            finished:false,
            page:1,
        }
    },
    computed: {
        ...mapState(['publicWelfareStaff']),
    },
    async created() {
      await this.init()

    },
    methods: {
      async init(){
        // await this.fetchData(1)
      },
      async fetchData(page){
            let DATA
            let sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                qa:1,
                page:page
            }
            await getPatientServiceList(sendData).then(res => {
                if(res.data){
                    DATA=res.data
                    console.log("getPatientServiceList",res)
                    this.list=[...this.list,...res.data]
                }
            }).catch(err => {

            })
            return DATA
        },

       async onLoad() {
        // 异步更新数据
        await this.fetchData(this.page).then(res => {
            console.log("fetchData",res)
            if (res.length>0) this.page++

            // 加载状态结束
            this.loading = false;

            // 数据全部加载完成
            if (res.length==0) {
                this.finished = true;
            }
        })
      },
      async goDetails(item){
          //标记当前项为已读
          if(item.type=='新增'){
            await sendQaStatus({patient_service_id:item.id}).then(res => {
              console.log("标记当前项为已读:",res.data)
            })
          }
          this.$router.push({
            name:'patientDetails',
            query:{
              showBottom:'true',
              // route:item.type=='患者服务'?'addService':'-1',
              // route:item.type=='新增'?'addService':'-1',
              route:'addService',
              noticeText:item.content,
              copyText: item.mobile
            }
          })
      }
    }
};
</script>

<style lang="less" scoped>
.news-feed {
    min-height: 100vh;
    background-color: #F9F9F9 ;
    .cell-container{
      background-color: #ffffff ;
      border-bottom: 1px solid #ebedf0;
      ::v-deep .van-cell__value{
        flex:3;
      }
      ::v-deep .van-cell::after {
          border-bottom:none;
      }
      .content{
        color:#888888;
        padding-left:16px;
        padding-bottom:10px;
      }
      .news-title{
          font-size: 16px;
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items:center;
          .title{
            white-space: nowrap;
          }
          .new{
              margin-left: 10px;
              font-size:10px;
              height: 18px;
          }
      }
    }

}
</style>